import { render } from "./tree-kind-dialog.vue?vue&type=template&id=f6b0290a&scoped=true"
import script from "./tree-kind-dialog.vue?vue&type=script&lang=js"
export * from "./tree-kind-dialog.vue?vue&type=script&lang=js"

import "./tree-kind-dialog.vue?vue&type=style&index=0&id=f6b0290a&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6b0290a"]])

export default __exports__